import { ReplacementState, ReplacementListRelated } from '..';
import { ReplacementListState } from './ReplacementListState';

export default class ReplacementInscriptionData {
    private _currentReplacementListState: ReplacementListState;
    private _statusList: ReplacementState[];
    private _replacementListRelatedList: ReplacementListRelated[] | null;

    public constructor(data: any) {
        this._currentReplacementListState = data.currentReplacementListState;
        this._statusList = data.replacementStates.map(replacementState => new ReplacementState(replacementState));
        this._replacementListRelatedList = data.replacementListRelated && data.replacementListRelated.length > 0 ? data.replacementListRelated.map(replacementList => new ReplacementListRelated(replacementList)) : null;
    }

    public get currentReplacementListState() {
        return this._currentReplacementListState;
    }

    public set currentReplacementListState(currentReplacementListState: ReplacementListState) {
        this._currentReplacementListState = currentReplacementListState;
    }

    public get statusList() {
        return this._statusList;
    }

    public get replacementListRelatedList() {
        return this._replacementListRelatedList;
    }
}
